
import Vue from "vue";
import AppLabelLayoutEditor from "@/components/label-layout-editor/LabelLayoutEditor.vue";
import { LabelLayoutModel } from "@/models/label-layout/label-layout-model";
import { LabelLayoutData } from "@/models/label-layout/label-layout-data";
import { BrowseService, LabelLayoutService } from "@/services";

export default Vue.extend({
	data(){
		return {
			layout: new LabelLayoutModel(),
			isSaving: false
		};
	},
	methods: {
		async save(){
			if (this.isSaving) return;
			this.isSaving = true;
			try{
				let result:LabelLayoutModel;
				if (this.layout.ID){
					result = await LabelLayoutService.updateLayout(this.layout);
				}else {
					result = await LabelLayoutService.createLayout(this.layout);
				}
				this.layout.ID = result.ID;
				if (this.layout.Data && result.Data) {
					this.layout.Data.ID = result.Data.ID;
				}
				this.$wf.notify(this.$ct("common.success"), "success", 3000, "check");
			}catch(err){
				this.$wf.notify(this.$ct("common.error"), "danger", 3000, "exclamation-triangle");
			}
			this.isSaving = false;
		}
	},
	async created(){
		await BrowseService.getBrowses();
		let browseId = this.$route.params["browseId"];
		if (browseId) {
			this.layout.BrowseID = parseInt(browseId) || 1;
			this.layout.Data = new LabelLayoutData();
			this.layout.Data.Data.BrowseID = this.layout.BrowseID;
			return;
		}
		let layoutId = parseInt(this.$route.params["id"]);
		this.layout = await LabelLayoutService.getById(layoutId);
	},
	components: {
		AppLabelLayoutEditor
	}
});
